import React, { useCallback, useContext } from 'react';

import { TrainersContext } from '../../trainers.context';
import TrainerForm from '../TrainerForm';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(TrainersContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <TrainerForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
